import React from 'react';
import { motion } from 'framer-motion';
import { contactInfo, contactMethods, socialLinks } from '../../data/contact';
import './ContactInfo.css';

const ContactInfo = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.div
      className="contact-info"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <div className="contact-info__header">
        <motion.h3 variants={itemVariants}>
          Vamos trabalhar juntos?
        </motion.h3>
        <motion.p variants={itemVariants}>
          {contactInfo.description}
        </motion.p>
      </div>

      <motion.div className="contact-info__items" variants={itemVariants}>
        {contactMethods.map((method) => (
          <motion.div 
            key={method.id} 
            className="contact-info__item"
            whileHover={{ x: 5 }}
          >
            <div className="contact-info__icon">
              {method.icon}
            </div>
            <div className="contact-info__content">
              <h4>{method.title}</h4>
              {method.link && method.link !== '#' ? (
                <a 
                  href={method.link} 
                  className="contact-info__link"
                  target={method.link.startsWith('http') ? '_blank' : '_self'}
                  rel={method.link.startsWith('http') ? 'noopener noreferrer' : ''}
                >
                  {method.value}
                </a>
              ) : (
                <p>{method.value}</p>
              )}
              <p>{method.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <motion.div className="contact-info__social" variants={itemVariants}>
        <h4>Redes Sociais</h4>
        <div className="contact-info__social-links">
          {socialLinks.map((social) => (
            <motion.a
              key={social.id}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-info__social-link"
              style={{ backgroundColor: `${social.color}20` }}
              whileHover={{ 
                y: -3, 
                backgroundColor: social.color,
                color: 'white'
              }}
              whileTap={{ scale: 0.9 }}
            >
              {social.icon}
            </motion.a>
          ))}
        </div>
      </motion.div>

      <motion.div className="contact-info__cta" variants={itemVariants}>
        <h4>Pronto para começar?</h4>
        <p>
          Entre em contato comigo e vamos discutir como posso ajudar 
          seu projeto a alcançar o próximo nível.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default ContactInfo;